import { SET_VERSION, OPEN_REFRESH_DIALOG, CLOSE_REFRESH_DIALOG } from '../../constant';

const setVersion = (version) => ({
  type: SET_VERSION,
  version: version,
});

const openRefreshDialog = () => ({
  type: OPEN_REFRESH_DIALOG,
});

const closeRefreshDialog = () => ({
  type: CLOSE_REFRESH_DIALOG,
});

export { setVersion, openRefreshDialog, closeRefreshDialog };
